module.exports = __webpack_public_path__ + "static/img/footer6.20b2450e.png";